/**
 * ElasticQuestion object is responsible for managing
 * question and answers state and data and also for fields validation
 */
class ElasticQuestion extends ElasticInterface {
    /** @returns {string} */
    static get STATE_PENDING () { return 'pending'; }
    /** @returns {string} */
    static get STATE_VALID () { return 'valid'; }
    /** @returns {string} */
    static get STATE_INVALID () { return 'invalid'; }

    /**
     * Simple factory to create proper form Field
     * @param question
     * @returns {Field}
     */
    static fieldFactory (question) {
        switch (question.type) {
            case 'single':
                return new SingleChoiceField(question);
            case 's_image':
                return new SingleImageChoiceField(question);
            case 'm_image':
                return new MultipleImageChoiceField(question);
            case 'multiple':
                return new MultipleChoiceField(question);

            case "f_surname":
                return new FirstAndSurnameField(question);
            case 'number':
                return new NumberField(question);
            case 'tel':
                return new PhoneField(question);

            case 'date':
                return new DatetimeField(question);

            case 'email':
                return new EmailField(question);

            case 'map':
                return new MapField(question);

            case "permission":
                return new PermissionField(question);

            case "long_input":
                return new LongTextField(question);

            default:
                return new TextField(question);
        }
    }

    constructor (question) {
        super();
        this.assignObjKeys(question);

        this.field = ElasticQuestion.fieldFactory(this);
        this.reply = [];
        this.validation = {};

        this.setState();
    }

    /**
     * Sets state based on validation status
     */
    setState () {
        switch (this.validation.status) {
            case true:
                this.state = ElasticQuestion.STATE_VALID;
                break;

            case false:
                this.state = ElasticQuestion.STATE_INVALID;
                break;

            default:
                this.state = ElasticQuestion.STATE_PENDING
        }
    }

    /**
     * Render question header, validation messages and form Field.
     * Rendering is partially delegate to Field class
     * @returns {string} valid HTML
     */
    render () {
        let
            validation = `<span class="center-block validation-error">${this.validation.message}</span>`,
            header = `<h3 class="elastic-question ${this.type}">
                          <span class="elastic-question-content">${this.content}</span>
                          <small class="elastic-hint center-block">${this.hint}</small>
                          ${this.state === ElasticQuestion.STATE_INVALID ? validation : ''}
                      </h3>`;

        return `<div class="elastic" data-question="${this.id}">${header + this.field.render()}</div>`;
    }

    init(){
        let props = jQuery.parseJSON(this.props);
        this.field.init(props);
    }

    /**
     * Perform validation of given answers.
     * Validation is delegate to Field class
     */
    validate () {
        let inputs = $(`.elastic[data-question="${this.id}"]`).find('input, textarea');

        if (inputs.length > 0) {
            this.reply = [];
            inputs.each((index, element) => {
                element = $(element);
                let answer = this._fetchAnswers(element);
                if (typeof answer.value != 'undefined') {
                    this.reply.push(answer);
                }
            });
        }
        this.validation = this.field.validate();
        this.setState();
    }

    /**
     * Serializes all given answers
     * @returns {{question_id, replies: (Array<Object>)}}
     */
    serialize () {
        return {
            question_id: this.id,
            replies: this.reply
        };
    }

    /**
     * Fetches answers and additional data from DOM element
     *
     * @param input
     * @returns {{tags: (string), name: (string), value: (string), type: (string)}}
     * @private
     */
    _fetchAnswers (input) {
        input = $(input);
        let result = {};

        if ((input.attr('type') == 'radio' || input.attr('type') == 'checkbox') && ! input.is(':checked')) {
            return result;
        }

        result.tags = input.data('tags');
        result.name = input.attr('name');
        result.answer_id = input.data('answer-id');
        result.label = null;

        switch(input.data('origin')) {
            case 'custom':
                result.type = 'custom_answer';
                result.value = input.closest('.custom_answers')
                                    .find('input[name="custom_answer"][type="text"]').val();
                break;

            case 'available':
                result.type = 'available_answer';
                result.value = input.val();
                result.label = input.closest('.available_answers').find(`label[for="${input.attr('id')}"]`).text();
                break;

            case 'predefined':
                result.type = 'predefined_answer';
                result.value = input.val();
                break;
        }

        return result;
    }

    /**
     * Destructs Question data to allow GarbageCollector do it's job.
     */
    destructor () {
        this.reply = undefined;
        this.state = undefined;
        this.validation = undefined;
        this.field = undefined;
    }
}
